import { useEffect, useState } from "react";
import { http } from "../lib/api";

// Cache condivisa della config (una sola chiamata per sessione)
let cfgPromise = null;
const getCfg = () => (cfgPromise ||= http.get("/paypal/config").then((r) => r.data).catch(() => ({ enabled: false })));

/**
 * Pulsante PayPal (metodo alternativo — Stripe resta principale).
 * Flusso redirect 100% server-side: nessuna credenziale passa dal browser.
 * Non renderizza nulla finché PayPal non è configurato nel backend.
 */
export const PayPalButton = ({ lookup_key, subscription = false, testid, dark = false }) => {
  const [enabled, setEnabled] = useState(false);
  const [busy, setBusy] = useState(false);

  useEffect(() => { getCfg().then((c) => setEnabled(!!c.enabled)); }, []);
  if (!enabled) return null;

  const onClick = async () => {
    setBusy(true);
    try {
      const path = subscription ? "/paypal/subscribe" : "/paypal/order";
      const { data } = await http.post(path, { lookup_key, origin_url: window.location.origin });
      window.location.href = data.approve_url;
    } catch { setBusy(false); }
  };

  return (
    <button data-testid={testid} onClick={onClick} disabled={busy}
      className={`w-full inline-flex items-center justify-center gap-2 text-xs font-semibold uppercase tracking-[0.15em] border px-8 py-3.5 transition-colors disabled:opacity-50
        ${dark ? "border-white/60 text-white hover:bg-white/10" : "border-[var(--petrol)] text-[var(--petrol)] hover:bg-[var(--paper-2)]"}`}>
      {busy ? "Reindirizzamento…" : "Paga con PayPal"}
    </button>
  );
};
